import {EventEmitter, Injectable} from '@angular/core';
import {IUserDataDto} from '../../../store/actions/IUser-data.dto';
import {IAddNoteResponse} from '../contract-control/contract-control.service';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  /** Profile data emitter */
  private eventEmitter = new EventEmitter<{data:IUserDataDto}>();
  
  /** Notes emitters */
  private notesEventEmitter = new EventEmitter<IAddNoteResponse>();
  // private editNoteEventEmitter = new EventEmitter<any>(); // unused
 // private updateNoteEventEmitter = new EventEmitter<any>(); //unused

  /** Tasks emitters */
  // private createTaskEmitters = new EventEmitter<any>();//unused


  /**
   * Update profile data on event emitter
   * @param data 
   */
  emitEvent(data: {data:IUserDataDto}) {
    this.eventEmitter.emit(data);
  }


  /**
   * Get updated profile date from event
   * @returns array | object
   */
  getEventEmitter() {
    return this.eventEmitter;
  }



  /**
   * Patch contract control notes event
   * @param data 
   */
  emitNotesEvent(data: IAddNoteResponse){
    this.notesEventEmitter.emit(data);
  }
  

  /**
   * Get contract control events data
   * @returns array | object
   */
  getNotesEventEmitter(){
    return this.notesEventEmitter;
  }



  /**
   * When user click on edit note then trigger data in event
   * @param data 
   */
  // unused
  // editNotesEvent(data: any){
  //   this.editNoteEventEmitter.emit(data);
  // }


  /**
   * Get Edit data from this event when user click on edit note
   * @returns 
   */
  // unused
  // getEditNoteEventEmitter(){
  //   return this.editNoteEventEmitter;
  // }


  /**
   * Patch updated note data
   * @param data
   */
  // seems to bo unused
  // patchUpdatedNoteEventEmitter(data: any){
  //   this.updateNoteEventEmitter.emit(data);
  // }



  /**
   * Return updated note data to upcoming events
   * @returns 
   */
  // seems to be not used
  // getUpdatedNoteEventEmitter(){
  //    return this.updateNoteEventEmitter;
  // }



  /**
   * Create task event
   * @param data
   */
  // seems to be unused
  // patchTaskData(data:any){
  //   this.createTaskEmitters.emit(data);
  // }


  /**
   * Get created task data
   * @returns emitter
   */
  // seems to be unused
  // getTaskData(){
  //   return this.createTaskEmitters;
  // }

}
